import { AssignmentStrategy } from "@gsp-wf/wf-process-model";
import { AssignConfig } from "./AssignConfig";

export class AssignStrategy {
    assignStrategy: AssignmentStrategy;
    assignConfig: AssignConfig;
}